import LegalLayout, { LegalSection } from "@/components/site/LegalLayout";
import { BRAND } from "@/lib/brand";
import SEO from "@/components/SEO";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service" updatedAt="June 2026" testid="terms-page">
      <SEO title="Terms of Service" description="Terms governing use of Greinch WW LLC website and services." path="/terms" />
      <p>
        These Terms of Service ("Terms") govern your access to and use of the website operated by
        {" "}{BRAND.name} ("GREINCH", "we" or "us") and any related services we provide. By using our
        website you agree to these Terms.
      </p>

      <LegalSection heading="1. Services">
        <p>
          GREINCH provides international B2B services that include software development, system
          integrations and brokerage / intermediation between clients, suppliers and partners.
          Specific terms for paid engagements are set out in a separate written agreement.
        </p>
      </LegalSection>

      <LegalSection heading="2. Use of the website">
        <ul className="list-disc list-outside pl-5 space-y-1">
          <li>You agree to use the website only for lawful purposes.</li>
          <li>You will not attempt to disrupt or compromise the security of the website.</li>
          <li>You will not scrape, reverse engineer, or misuse content.</li>
        </ul>
      </LegalSection>

      <LegalSection heading="3. Intellectual property">
        <p>
          All content on this website — including text, graphics, logos, the GREINCH brand and
          source code — is owned by or licensed to GREINCH and is protected by applicable
          intellectual property laws. You may not reproduce or redistribute any part without
          written permission.
        </p>
      </LegalSection>

      <LegalSection heading="4. Submissions">
        <p>
          If you submit information through forms (such as contact requests or project briefs),
          you confirm the information is accurate and that you are authorised to share it. We
          treat such information confidentially in line with our{" "}
          <a href="/privacy" className="text-coral hover:underline">Privacy Policy</a>.
        </p>
      </LegalSection>

      <LegalSection heading="5. Brokerage disclaimer">
        <p>
          When GREINCH acts as an intermediary or broker, we facilitate introductions and
          coordination between parties. Unless explicitly stated in writing, GREINCH is not a
          party to the underlying commercial transaction between the introduced parties and is
          not liable for the performance of either party.
        </p>
      </LegalSection>

      <LegalSection heading="6. No warranties">
        <p>
          The website is provided "as is" without warranties of any kind, express or implied.
          We do not guarantee that the website will be uninterrupted, error-free, or free of
          harmful components.
        </p>
      </LegalSection>

      <LegalSection heading="7. Limitation of liability">
        <p>
          To the maximum extent permitted by law, GREINCH and its affiliates shall not be liable
          for any indirect, incidental, special, consequential or punitive damages arising out of
          or related to your use of the website.
        </p>
      </LegalSection>

      <LegalSection heading="8. Governing law">
        <p>
          These Terms are governed by the laws of the State of Wyoming, USA, without regard to
          its conflict of law principles. Any dispute shall be brought in the competent courts
          located in Wyoming, USA, unless otherwise required by mandatory law.
        </p>
      </LegalSection>

      <LegalSection heading="9. Changes">
        <p>
          We may update these Terms from time to time. The latest version will always be posted
          on this page with an updated date.
        </p>
      </LegalSection>

      <LegalSection heading="10. Contact">
        <p>
          For any question about these Terms, contact us at{" "}
          <a href={`mailto:${BRAND.email}`} className="text-coral hover:underline">
            {BRAND.email}
          </a>.
        </p>
        <p>
          {BRAND.name}<br />
          {BRAND.address}<br />
          {BRAND.addressLine2}
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
